import { InjectionToken } from '@angular/core';
import { Subject } from 'rxjs';

export const GLOBAL_CACHE_BUSTER_NOTIFIER = new Subject<void>();

export const GLOBAL_CACHE_BUSTER_NOTIFIER_TOKEN = new InjectionToken('Global cache buster notifier', {
  providedIn: 'root',
  factory: () => GLOBAL_CACHE_BUSTER_NOTIFIER,
});
